module.exports = __webpack_public_path__ + "img/type2_bg1.3f12c315.png";